module.exports = __webpack_public_path__ + "img/patrolManagement.b2b656d5.svg";